import React, { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import Page from '../../components/Page';
import LoadingSpinner from '../../components/Spinner';
import { Tab, Tabs } from '../../components/TabMenu';
import { getTabSelectOptions } from '../../constants/tabMenuTypes';
import { getCompanyDepartments, selectCompanyId } from '../../redux/modules/company';
import { getUserSettings, selectUserId, selectUserSettings } from '../../redux/modules/user';

const UserSettingsPage = () => {
  const dispatch = useDispatch();
  const tabMenuOptions = getTabSelectOptions('userSettingsMenuTabs');
  const userId = useSelector(selectUserId);
  const companyId = useSelector(selectCompanyId);
  const userSettings = useSelector(selectUserSettings);

  useEffect(() => {
    if (userId && companyId) {
      dispatch(getUserSettings());
      dispatch(getCompanyDepartments());
    }
  }, [userId, companyId]); // eslint-disable-line

  if (!userSettings) return <LoadingSpinner />;

  return (
    <Page fixedHeight backgroundColor="grey">
      <Tabs layerStyle="tabPanel">
        {tabMenuOptions.map(option => (
          <Tab
            {...option}
            key={option.tabId}
          />
        ))}
      </Tabs>
    </Page>
  );
};

export default UserSettingsPage;
